import React from 'react';
import { Divider, Spin } from 'antd';
import TabPartTitle from '@app/product/TabPartTitle';
import { IScrollToAnchorConfig } from 'base/utils/scrollTo';
import { useTrans } from 'base/utils/i18n';
import { IReviewPage } from 'mod/review/interface';
import { useReviewPage } from 'mod/review/useReviewPage';
import { ReviewsAverage } from 'mod/review/ReviewsAverage';
import { ReviewsAssetsFilter } from 'mod/review/ReviewsAssetsFilter';
import { ReviewListPC } from 'mod/review/ReviewListPC';
import ThemePagination from '@base/lib/ThemePagination';
import cn from 'classnames';
import styles from './index.module.less';

interface IProps {
    id?: string;
    variant: {
        variantId: string;
        review: {
            score: number | string;
            reviewNum: number;
        };
    };
    from?: IScrollToAnchorConfig['from'];
    initialReviewPage?: IReviewPage;
}

const ProductReviewList: React.FC<IProps> = (props) => {
    const { t } = useTrans();
    const { id = 'review-list', variant, from, initialReviewPage } = props
    const reviewInfo = variant.review;
    const score = reviewInfo ? +reviewInfo.score : 5;
    const total = reviewInfo.reviewNum || 0;

    const {
        anchorRef,
        reviewPage,
        loading,
        onPageChange,
        withPictures,
        onWithPicturesChange,
        afterCount,
    } = useReviewPage({
        variantId: variant.variantId,
        initialReviewPage,
        from
    });

    return score > 0 ? (
        <div
            id={id}
            className={cn(styles['review-list-wrap'], 'wrapper')}
        >
            <TabPartTitle title={t('web_product_tab_reviews', { num: total })}/>

            <ReviewsAverage className={styles.average} score={score} rateSize={18}/>

            <Spin spinning={loading}>
                {!reviewPage ? null : (
                    <>
                        <div ref={anchorRef}/>

                        <ReviewsAssetsFilter
                            className={styles['filter']}
                            reviewPage={reviewPage}
                            withPictures={withPictures}
                            onWithPicturesChange={onWithPicturesChange}
                        />

                        <Divider style={{ margin: '8px 0 20px', }}/>

                        <ReviewListPC
                            className={styles.reviews}
                            list={reviewPage.list}
                            afterCount={afterCount}
                        />

                        {reviewPage.totalPage > 1 && (
                            <ThemePagination
                                total={reviewPage.totalNum || 0}
                                pageSize={10}
                                current={reviewPage.page || 1}
                                onChange={onPageChange}
                            />
                        )}
                    </>
                )}
            </Spin>
        </div>
    ) : (
        <div className={cn(styles['no-score'], 'text-center')}>{t('web_product_review_no_score')}</div>
    )
}

export default React.memo(ProductReviewList)
